import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { APP_CONFIG } from 'src/app/config/app-config.module';
import { AppConfig } from 'src/app/core/config-models/app-config.model';
import { ILegalEntitiesCreateBusinessRequest } from 'src/app/features/todos/models/create-business.model';
import { ILegalEntityTypesResponse } from 'src/app/static-data/models/legal-entity-types.model';
import { SearchLegalEntitiesComponent } from '../search-legal-entities/search-legal-entities.component';
import * as fromStaticDataSelector from '../../../static-data/selectors';
import * as fromToDosAction from '../../../features/todos/actions';
import * as fromLegalEntityActions from '../../../features/legal-entities/actions';

@Component({
  selector: 'app-add-sub-legal-entity',
  templateUrl: './add-sub-legal-entity.component.html',
  styleUrls: ['./add-sub-legal-entity.component.css']
})
export class AddSubLegalEntityComponent implements OnInit {
  @Input() parentLegalEntityId: string = '';
  @Output() closeDialog = new EventEmitter<void>();

  fileName: string;
  toUploadEndpoint: string;
  newLegalEntity: string;
  decision: string = 'false';
  showFSPInput: boolean = false;
  fspNumber: string;

  subscription: Subscription = new Subscription();
  selectedCountry: ILegalEntityTypesResponse;
  selectedCountryId: string;
  newCountryNameResults: any[] = [];
  countryId: string;
  radioValues: any[];
  selectionRadio: number = 2;

  constructor(
    @Inject(APP_CONFIG) private appConfig: AppConfig,
    private store: Store
  ) {
    this.newLegalEntity = undefined;

    this.radioValues = [{
      id: 1, valueText: 'Yes', value: 'yes'
    },{
      id: 2, valueText: 'No', value: 'no'
    }];
  }

  ngOnInit(): void {
    this.newLegalEntity = undefined;
    this.loadLegalEntityTypes();
  }

  uploadDoc(fileId) {
    this.fileName = `ProofBusinessRegistration/${fileId}`;
  }

  myUploader(event) {
  }

  onLegalEntityTypeValueChanged(e){
    this.selectedCountryId = e.value;
  }

  loadLegalEntityTypes(){
    this.subscription.add(
      this.store.select(fromStaticDataSelector.selectLegalEntityTypes).subscribe((country: any[]) => {
        this.newCountryNameResults = [];
        this.newCountryNameResults = country;
      })
    );
  }

  searchCountryNames(val) {
    this.subscription.add(
      this.store.select(fromStaticDataSelector.selectLegalEntityTypes).subscribe(country => {
        this.newCountryNameResults = country.filter(value => {
          let newValues = value.description.toLowerCase();
          return newValues.startsWith(val.query.toLowerCase());
        });
      })
    );
  }

  cancel() {
    this.closeDialog.emit();
    this.newLegalEntity = undefined;
  }

  decisionSelection() {
    if (this.decision === 'true') {
      this.showFSPInput = true;
    } else {
      this.showFSPInput = false;
    }
  }

  onRadioValueChanged(e){
    if (e.value === 1) {
      this.showFSPInput = true;
    } else {
      this.showFSPInput = false;
    }
  }

  submitNewLegalEntity() {

    this.countryId = this.selectedCountryId === undefined ? this.newCountryNameResults[0].id : this.selectedCountryId;

    if (this.newLegalEntity !== undefined && this.countryId !== undefined) {
      const req: ILegalEntitiesCreateBusinessRequest = {
        fspNumber: this.fspNumber,
        legalEntityName: this.newLegalEntity,
        legalEntityTypeId: this.countryId,
        parentLegalEntityId: this.parentLegalEntityId,
        isAssetManager: false
      };

      this.store.dispatch(
        fromLegalEntityActions.loadAddSubLegalEntity({
          request: req,
          businessId: sessionStorage.getItem('businessId')
        })
      );
      this.closeDialog.emit();
      this.newLegalEntity = undefined;
    }
  }
}
